import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChange, SimpleChanges, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { AppConfig } from '@solar/app.config';

import { Site } from 'solar-bo';;

import { MessageError } from 'base-models';
import { Supervision } from 'solar-bo';
import { AlertType } from 'base-models';
import { GlobalService } from '@solar/services/global.service';
import { SiteFilterComponent } from '../../site/site-filter/site-filter.component';
import { SortHelper } from 'shtools';
import { SupervisEditDlgComponent } from '../supervis-edit/supervis-edit-dlg.component';
import { DialogdeleteComponent } from 'basecomponents';
import { SupervisionStatusEnum } from 'solar-bo';
import { ControlEnum } from 'solar-bo';
import { SupervStatusIconComponent } from '../superv-status/supervstatusicon.component';
import { SolarBase1Component } from '@solar/solar/solar-base/solar-base1.component';


@Component({
  selector: 'app-supervis-list',
  templateUrl: './supervis-list.component.html'
  , styleUrls: ['./supervis-list.component.scss']
})
export class SupervisListComponent extends SolarBase1Component implements OnInit, OnChanges, AfterViewInit {

  @Input() routeActive = true;
  @Input() site: Site;
  @Input() siteMode: boolean = false;//como no carga el site inmediatamente debemos concretarlo
  @Input() viewOptions: any[];
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @Input() showSiteCol: boolean = true;
  @ViewChild('filterbysite', { static: false }) filterbysite: SiteFilterComponent;
  @Output() supervisionSelectedEvent:EventEmitter<Supervision>=new EventEmitter();

  sitelist: Site[];
  siteListForFilter: Site[];
  /**
   * Filter Status List
   */
  statusList=[];

  highlightedRows = [];

  public dt_filterQuery = "";
  public dt_rowsOnPage = 5;
  public dt_sortBy = "contractname";
  public dt_sortOrder = "asc";
  statusCanBeChanged:boolean=false;

  constructor(public globService: GlobalService
    ) {
    //super(dialog, globService,route,baseService,router);
    super();
    this.statusCanBeChanged = this.globService.checkAuthorizationById(ControlEnum.SUPERVISION_CHANGE_STATUS);
    this.statusList.push({id:SupervisionStatusEnum.OPEN, name:"Open"});
    this.statusList.push({id:SupervisionStatusEnum.VALIDATED, name:"Validated"});
    this.statusList.push({id:SupervisionStatusEnum.TOVALIDATE, name:"ReValidate"});

  }

  ngOnInit() {
    if (this.siteMode) {

    }
    else {
      this.getList();
    }
  }

  ngAfterViewInit() {
    //console.log("ngAfterViewInit");
    if (this.filterbysite) {
      this.filterbysite.onFilterChange.subscribe((result) => this.onSiteSelectionChange(result));
    }
    else {

    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const typeChange = changes['site'];
    if (typeChange && typeChange.currentValue) {
      if (this.siteMode) {
        this.getList();
      }
    }
  }

  refresh() {
    this.getList();
  }

  getList(): void {
    this.listerrmessage = "";
    this.loading = true;
    /*     let filter = new FilterDTO();
        let filterbytypestring: any = (this.selectByStatus.getSelectBy() == null ? "-1" : this.selectByStatus.getSelectBy());
        filter.filteritems.push(new FilterParam("status", filterbytypestring));
    
        
        let filterbypropertystring: any = (this.filterbyproperty.getSelectBy() == null ? "-1" : this.filterbyproperty.getSelectBy());
        filter.filteritems.push(new FilterParam("propertyfilter", filterbypropertystring));
    
        let dtrange: DateRange = this.listdaterange.getDateRange();
        if (dtrange.dt_start != null) {
          filter.filteritems.push(new FilterParam("from", dtrange.getdtstart00String()));
        }
        if (dtrange.dt_end != null) {
          filter.filteritems.push(new FilterParam("to", dtrange.getdtend00String()));
        }
    
        filter.filteritems.push(new FilterParam("sortby", "modifydate desc")); */
    if (this.site == null) {
      this.solarService.supervisionsGetByFilter(null)
        .subscribe(
          res_list => this.getListhandleresult(res_list)
          , err => this.getListhandleError(err)
        );
    }
    else {
      this.solarService.siteGetSupervisions(this.site.id)
        .subscribe(
          res_list => this.getListhandleresult(res_list)
          , err => this.getListhandleError(err)
        );
    }

  }

  getListhandleresult(newlist: any[]) {
    console.log('getListhandleresult', newlist);
    this.listerrmessage = '';
    this.loading = false;
    newlist = SortHelper.sortMultiple(newlist, ["info.supervisionDate"], ['desc']);
    this.listOriginal = newlist;
    this.configSitelistForFilter();
    this.configsource(this.listOriginal);
    this.alertmessage = null;
    
  }

  private configSitelistForFilter() {
    if (this.siteListForFilter) {
      return;
    }
    this.siteListForFilter = [];

    
    try {
      let distinctItems = this.listOriginal.filter(
        (thing, i, arr) => arr.findIndex(t => t.site.id === thing.site.id) === i
      );
      //distinctItems = SortHelper.sortMultiple(distinctItems, ["site.name"], ['asc']);
      distinctItems = distinctItems.sort((a, b) => SortHelper.sortByStringLocale(a.site.name, b.site.name));
      distinctItems.forEach(elem => {
        this.siteListForFilter.push(elem.site);

      });
    }
    catch (err) {
      console.log("configSitelistForFilter", err);
    }


  }

  onSiteSelectionChange(siteid) {
    this.filter_siteid=siteid;
    this.filterList();
    return;
    if (siteid == -1) {
      //all sites
      this.site = null;
      this.listFiltered=this.listOriginal.slice();
      return;
    }

    this.site = new Site();
    this.site.id = siteid;
    this.getList();
  }

  filter_siteid=-1;//all
  filter_statusid=[];//all
  filterList(){
    let lst=this.listOriginal.slice();
    if (this.filter_siteid!=-1){
      lst=lst.filter(item=>item.site.id==this.filter_siteid);
    }
    if (this.filter_statusid.length>0){
      for(let st of this.filter_statusid){
        lst=lst.filter(item=> this.filter_statusid.includes(item.info.status));//usar array, pero con pocos elementos da igual
      }
      
    }
    this.listFiltered = lst;
  }

  filterbystatusOnItemSelectedHandler($event){
    console.log("filterbystatusOnItemSelectedHandler",$event);
    let lstFilter=$event as Array<any>;
    let lst=[];
    for(let st of lstFilter){
      lst.push(st.id);
    }
    this.filter_statusid=lst;
    this.filterList();
  }

  showmessage(message: string) {
    this.alertmessage = new MessageError(AlertType.Success, message);
  }

  configsource(data) {
    this.listFiltered = data;
  }

  sortData(sort: Sort) {
    const data = this.listOriginal.slice();
    if (!sort.active || sort.direction === '') {
      this.listFiltered = data;
      return;
    }
    let fieldToSort: string = sort.active;
    switch (sort.active) {
      case 'status':
        fieldToSort = "info.status";
        break;
      case 'site':
        fieldToSort = "site.name";
        break;
      case 'supervisiondate':
        fieldToSort = "info.supervisionDate";
        break;
      default:
        break;
    }

    let isAsc = sort.direction;//=== 'asc';

    this.listFiltered = SortHelper.sortMultiple(this.listOriginal, [fieldToSort], [isAsc]);

    this.configsource(this.listFiltered);

  }

  getListhandleError<T>(err: any) {
    console.log("getListhandleError");
    this.loading = false;
    this.handleError(err, "Error retrieving supervisions list");
  }

  uiisdeletable(supervision: Supervision) {
    if(!Supervision){
      return false;
    }
    if (supervision.info.status == SupervisionStatusEnum.VALIDATED) {
      return false;
    }
    else{
      let res=this.acl_btn_bysite(ControlEnum.BTN_SUPERVISION_EDIT,supervision.site);
      return res;
    }
    
  }

  canChangeStatus(superv:Supervision){
    if (this.statusCanBeChanged == false) {
      return false;
    }

/*     if (this.options.readonly == false) {
      this.statusCanBeChanged = this.globService.checkAuthorizationById(ControlEnum.SUPERVISION_CHANGE_STATUS);
  } else {
      this.statusCanBeChanged = false;
  } */
  }

  supervisionChangeStatus(supervision: Supervision, icostatus:SupervStatusIconComponent ) {
    if(!Supervision){
      return false;
    }
    console.log(icostatus);
    icostatus.openStatusChange();
  }

  supervision_Selected(item: Supervision){
    this.supervisionSelectedEvent.emit(item);
  }

  openitem(item: Supervision) {

    //this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/supervision-master/" + item.id);
    //this.router.navigate(['site/' , item.id],{relativeTo:this.route});
  /*   let itemPath={path:"/supervision-master/" + item.id};
    this.globService.menuSelectedEvent_raise(itemPath); */
    if (this.routeActive) {
     this.navigateto("/supervision-master/" + item.id);
    } else {
      this.supervisionSelectedEvent.emit(item);
    }
  }

 

  newsupervision(site?: Site) {
    let dialogRef: MatDialogRef<SupervisEditDlgComponent>;
    let supervis = new Supervision();
    supervis.site = site;
    dialogRef = SupervisEditDlgComponent.openModalWithModel(this.dialog, true, supervis);
    dialogRef.componentInstance.saveEvent.subscribe((resultModel) => this.saveSupervisionEvent(dialogRef, null, resultModel));

  }

  saveSupervisionEvent(dialogRef: MatDialogRef<any>, itemToEdit: Site, resultModel: Supervision) {
    dialogRef.close();
    this.navigateto('/supervision-master/' + resultModel.id);
  }

  supervisionDelete(supervision: Supervision) {
    this.openDialogDeletesSupervision(supervision);
  }

  openDialogDeletesSupervision(model: Supervision) {

    let dialogRef = this.openDialogDelete("Delete Supervision", "Do you want to delete supervision: " + model.name, model);
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => this.deleteSupervisionHandler(model, dialogRef));
  }

  deleteSupervisionHandler(model: Supervision, dialogRef: MatDialogRef<DialogdeleteComponent>, ) {
    console.log("deleteSupervisionHandler" + model.name);
    const dlgComp = dialogRef.componentInstance;
    dlgComp.lockdeletebtn();
    //dlgComp.addmessage("error","No se ha podido borrar el site");
    dialogRef.close();
    this.loadinglist = true;
    this.alertmessage = new MessageError(AlertType.Warning, "Deleting Supervision, please wait");
    this.solarService.supervisionDeleteById(model.id).subscribe(() => this.supervisionDeleteSuccessHandler(model.id), err => this.handleError(err, "Error deleting Supervision "));
  }

  supervisionDeleteSuccessHandler(id: string) {
    const index = this.listOriginal.findIndex(el => el.id == id, 0);
    if (index > -1) {
      this.listOriginal.splice(index, 1);
      this.configsource(this.listOriginal);
    }
    this.loadinglist = false;

    this.alertmessage = new MessageError(AlertType.Success, "Supervision deleted");
  }

  uiShowActionBtn(supervision: Supervision) {
    if (supervision.info.status == SupervisionStatusEnum.LOCKED
      || supervision.info.status == SupervisionStatusEnum.VALIDATED) {
      return false;
    }
    return true;
  }

  uiPowerLost(supervision: Supervision) {
    if (supervision.info.powerLost) {
      return supervision.info.powerLost / 1000;
    }
    else {
      return 0;
    }
  }

  
  gotoSite(event, site:Site) {
    event.stopPropagation();
    event.stopImmediatePropagation(); // optional in my case
    event.preventDefault(); // optional in my case
    //this.matTooltipChildren.forEach(elem => elem.hide());
    event = event || window.event;
    var target = event.target || event.srcElement;

    setTimeout(() => {
      //this.router.navigate([url]);
      this.globService.navigateToSite(site);
    }, 50);
  }

}



